export const WIDGET_INSET = 25;

export const WIDGET_INSET_PHONE = 15;

const PHONE_MAX_WIDTH = 480;

const phoneMedia = (): MediaQueryList => window.matchMedia(`(max-width: ${PHONE_MAX_WIDTH}px)`);

export const widgetInset = (): number => phoneMedia().matches ? WIDGET_INSET_PHONE : WIDGET_INSET;

export const subscribeWidgetInset = (listener: (inset: number) => void): (() => void) => {
    const media = phoneMedia();
    const handleChange = (): void => listener(widgetInset());

    media.addEventListener('change', handleChange);

    return () => media.removeEventListener('change', handleChange);
};
